import moment from 'moment'
import {FC, useEffect, useState, useCallback} from 'react'
import {set, useFormContext} from 'react-hook-form'
import {
  InputDateWrapper,
  InputTextWrapper,
  CheckWrapper,
  SelectWrapper,
} from '../../../../../../components/UI/Form/Input'
import {SelectAsyncWrapper} from '../../../../../../components/UI/Form/Input'
import {CampModel} from '../../../modules/models'
import {getCampsService, getMasterModuleService} from '../../../modules/services'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import Swal from 'sweetalert2'
import {
  getHuespedEsRelevoService,
  getModuleRelevoService,
  getRoomRelevoService,
  getBedRelevoService,
  getEstadoCamaService,
  getUltimaCamaUsadaDisponibleService,
  getModuloByEstadoService,
  getHabitacionesByEstadoService,
  getCamasByEstadoService,
  getCamaOcupadaPorHuespedService,
  getModuloDisponibleService,
  getCamasDisponibleService,
  getHabitacionesDisponibleService,
  getListCargosService,
} from '../../../../services/booking.service'
import {getListComboHuespedService} from '../../../../services/booking.service'
import {
  updateCargoGuestService,
  getGuestByIdService,
  updateTipoHuespedGuestService,
} from '../../../../services/guest.service'
import {getGrupoByUsuario} from '../../../../services/relevo.service'
import {ModalCreateGuest} from '../Modals/ModalCreateGuest'
import {GuestModel} from '../../../guests/model'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import clsx from 'clsx'
import InputNumberWrapper2 from '../../../../../../components/UI/Form/Input/numberWrapper2'
import {ModalInfoBedGuest} from '../Modals/ModalInfoBedGuest'
import {ModalCreateCargo} from '../Modals/ModalCreateCargo'
import {ModalLastGuests} from '../Modals/ModalLastGuests'
import {ModalLastBeds} from '../Modals/ModalLastBeds'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {SelectOption} from '../../../../../../models/utility.model'

const FormBookingftf: FC = () => {
  const {changeCurrentTabItem, currentTabItem} = useHoteleria()

  const [camps, setCamps] = useState<any[]>([])
  const [modules, setModules] = useState<any[]>([])
  const [rooms, setRooms] = useState<any[]>([])
  const [beds, setBeds] = useState<any[]>([])
  const [cargos, setCargos] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [status, setStatus] = useState<SelectOption[]>([])
  const [showModalCreateGuest, setShowModalCreateGuest] = useState<boolean>(false)
  const [showModalBedGuest, setShowModalBedGuest] = useState<boolean>(false)
  const [showModalCreateCargo, setShowModalCreateCargo] = useState<boolean>(false)
  const [showModalCreateStatus, setShowModalCreateStatus] = useState<boolean>(false)
  const [showModalLastGuests, setShowModalLastGuests] = useState<boolean>(false)
  const [showModalLastBeds, setShowModalLastBeds] = useState<boolean>(false)
  const [previousCargoId, setPreviousCargoId] = useState<string | null>(null)
  const [previousStatusId, setPreviousStatusId] = useState<string | null>(null)
  const [bedInfo, setBedInfo] = useState<{
    huespedNombre: string
    nroReserva: string
    fechaFinProgramada: string
  } | null>({huespedNombre: '', nroReserva: '', fechaFinProgramada: ''})
  const [pendingDocumento, setPendingDocumento] = useState<{numero: string; tipo: string} | null>(
    null,
  )

  const {setValue, watch, reset} = useFormContext()

  const habilitarHuespedRelevo = watch('HabilitarHuespedRelevo')
  const huespedRelevoTieneRelevo = watch('HuespedRelevoTieneRelevo')
  const campamentoId = watch('CampamentoId')
  const camaId = watch('CamaId')
  const huespedId = watch('HuespedId')
  const huespedRelevoId = watch('HuespedRelevoId')
  const fechaInicio = watch('FechaInicio')
  const fechaFin = watch('FechaFin')
  const tipoBusqueda = watch('tipoBusqueda')
  const nameGuest = watch('nameGuest')
  const bedStatus = watch('bedStatus')
  const isRelevo = watch('isRelevo')
  const relevoId = watch('relevoId')
  const camaIdFake = watch('CamaIdFake')
  const camaCalienteId = watch('CamaCalienteId')
  const loadingVolverRelevo = watch('loadingVolverRelevo')
  const camaConfigurada = watch('camaConfigurada')
  const dias = watch('dias')

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      noFormDetail: false,
    }
    changeCurrentTabItem(obj)
    getCampsList()
    getCargosFn()
    getStatusFn()
  }, [])

  const cargoId = watch('CargoId')
  const statusId = watch('TipoHuespedId')

  useEffect(() => {
    if (statusId === null || statusId === undefined) {
      setValue('TipoHuespedId', '')
    }
  }, [statusId, setValue])

  useEffect(() => {
    if (cargoId === null || cargoId === undefined) {
      setValue('CargoId', '')
    }
  }, [cargoId, setValue])

  useEffect(() => {
    // Solo ejecutar cuando el tipo de búsqueda es "disponibles"
    if (campamentoId) {
      setModules([])
      setValue('nameGuest', '')
      setValue('bedStatus', '')
      setRooms([])

      setBeds([])
    }
  }, [campamentoId])

  useEffect(() => {
    if (!huespedId) {
      setValue('nameGuest', '')
      setValue('CargoId', '')
      setPreviousCargoId(null)
      setPreviousStatusId(null)
    } else {
      // Cuando se selecciona un huésped, inicializar el cargo anterior
      const currentCargoId = watch('CargoId')
      setPreviousCargoId(currentCargoId || '')

      const currentStatusId = watch('TipoHuespedId')
      setPreviousStatusId(currentStatusId || '')
    }
  }, [huespedId])

  useEffect(() => {
    if (camaIdFake && campamentoId && beds.length > 0) {
      let camaIdReal = ''
      if (tipoBusqueda === 'disponibles') {
        camaIdReal = beds.find((c) => c.value === camaIdFake)?.Id || ''
      } else if (tipoBusqueda === 'ocupadas') {
        camaIdReal = beds.find((c) => c.value === camaIdFake)?.camaId || ''
      } else if (tipoBusqueda === 'relevo') {
        camaIdReal = beds.find((c) => c.value === camaIdFake)?.id || ''
      }
      getEstadoCama(camaIdReal)
      if (tipoBusqueda === 'relevo') {
        setValue('camaConfigurada', true)
      }
    }
  }, [camaIdFake, campamentoId, huespedId, beds])

  useEffect(() => {
    if (!camaId) {
      setValue('bedStatus', '')
      setValue('camaConfigurada', false)
    }
  }, [camaId])

  useEffect(() => {
    if (camaId && beds.length > 0) {
      if (tipoBusqueda === 'disponibles') {
        if (camaCalienteId) {
          setValue(
            'CamaIdFake',
            beds.find(
              (c) =>
                c.Id === camaId &&
                (c.CamaCalienteId === camaCalienteId || c.camaCalienteId === camaCalienteId),
            )?.value || '',
          )
        } else {
          setValue('CamaIdFake', beds.find((c) => c.Id === camaId)?.value || '')
        }
      } else if (tipoBusqueda === 'ocupadas') {
        if (camaCalienteId) {
          setValue(
            'CamaIdFake',
            beds.find(
              (c) =>
                c.camaId === camaId &&
                (c.CamaCalienteId === camaCalienteId || c.camaCalienteId === camaCalienteId),
            )?.value || '',
          )
        } else {
          setValue('CamaIdFake', beds.find((c) => c.camaId === camaId)?.value || '')
        }
      } else if (tipoBusqueda === 'relevo') {
        if (camaCalienteId) {
          setValue(
            'CamaIdFake',
            beds.find(
              (c) =>
                c.id === camaId &&
                (c.CamaCalienteId === camaCalienteId || c.camaCalienteId === camaCalienteId),
            )?.value || '',
          )
        } else {
          setValue('CamaIdFake', beds.find((c) => c.id === camaId)?.value || '')
        }
      }
    }
  }, [camaId, bedStatus, camaCalienteId])

  useEffect(() => {
    if (dias) {
      const newFechaFin = moment(fechaInicio).add(dias, 'days').format('YYYY-MM-DD')

      setValue('FechaFin', newFechaFin)
    }
  }, [dias])

  useEffect(() => {
    if (fechaInicio && fechaFin) {
      const inicio = moment(fechaInicio)
      const fin = moment(fechaFin)

      if (fin.isBefore(inicio)) {
        console.log('error')
        return
      }

      const diferencia = fin.diff(inicio, 'days')
      setValue('dias', diferencia)
    }
  }, [fechaInicio, fechaFin])

  const getCampsList = async () => {
    try {
      let obj: CampModel = {
        id: '',
        nombre: '',
        siteId: '',
        clienteId: '',
        companiaId: '',
        site: '',
        nombreCliente: '',
        nombreCompania: '',
        isCombo: true,
      }
      const response = await getCampsService(obj, 1)
      const data = response.data.data
      const mappedCamps = data?.map((camp) => ({value: camp.id, label: camp.nombre}))
      setCamps(mappedCamps || [])
    } catch (error) {
      setCamps([])
    }
  }

  const getModules = async (
    campamentoId: string,
    tipoBusqueda: 'disponibles' | 'ocupadas' | 'relevo',
    relevoId?: string,
  ) => {
    if (tipoBusqueda === 'disponibles') {
      const response = await getModuloDisponibleService({
        campamentoId: campamentoId,
      })

      const modulesData =
        response.data.data?.map((item) => ({value: item.Id, label: item.Descripcion})) || []
      setModules(modulesData)
    } else if (tipoBusqueda === 'ocupadas') {
      const response = await getModuloByEstadoService({
        CampamentoId: campamentoId,
      })
      const modulesData =
        response.data.data?.lstModulos.map((item: any) => ({
          value: item.moduloId || item.moduloId,
          label: item.codigoModulo || item.codigoModulo,
          ...item,
        })) || []
      setModules(modulesData)
    } else if (tipoBusqueda === 'relevo') {
      const response = await getModuleRelevoService({
        relevoId: relevoId || '',
        campamentoId: campamentoId || '',
      })
      const modulesData =
        response.data.data?.map((item: any) => ({
          value: item.id,
          label: item.codigo,
          ...item,
        })) || []
      if (modulesData.length > 0) {
        setValue('ModuloId', modulesData[0].value)
        await getRooms(campamentoId, modulesData[0].value, 'relevo', relevoId)
        setModules(modulesData)
      } else {
        const dto = {
          HuespedId: watch('HuespedId'),
        }
        const {data} = await getUltimaCamaUsadaDisponibleService(dto)
        const ultimaCamaData = data.data

        if (ultimaCamaData.estado === 'OCU') {
          setValue('tipoBusqueda', 'ocupadas')
          await getModules(campamentoId, 'ocupadas')
          setValue('ModuloId', ultimaCamaData.moduloId)
          await getRooms(campamentoId, ultimaCamaData.moduloId, 'ocupadas')
          setValue('HabitacionId', ultimaCamaData.habitacionId)
          await getBeds(campamentoId, ultimaCamaData.habitacionId, 'ocupadas')
          setValue('CamaId', ultimaCamaData.camaId)
          setValue('CamaCalienteId', ultimaCamaData.camaCalienteId || null)
        } else if (ultimaCamaData.estado === 'DIS') {
          setValue('tipoBusqueda', 'disponibles')
          await getModules(campamentoId, 'disponibles')
          setValue('ModuloId', ultimaCamaData.moduloId)
          await getRooms(campamentoId, ultimaCamaData.moduloId, 'disponibles')
          setValue('HabitacionId', ultimaCamaData.habitacionId)
          await getBeds(campamentoId, ultimaCamaData.habitacionId, 'disponibles')
          setValue('CamaId', ultimaCamaData.camaId)
          setValue('CamaCalienteId', ultimaCamaData.camaCalienteId || null)
        } else {
          setValue('tipoBusqueda', 'disponibles')
          await getModules(campamentoId, 'disponibles')
        }
      }
    }
    try {
    } catch (error) {
      setModules([])
    }
  }

  const getRooms = async (
    campamentoId: string,
    moduloId: string,
    tipoBusqueda: 'disponibles' | 'ocupadas' | 'relevo',
    relevoIdAux?: string,
  ) => {
    try {
      if (tipoBusqueda === 'disponibles') {
        const response = await getHabitacionesDisponibleService({
          moduloId: moduloId,
        })
        const roomsData =
          response.data.data?.map((item) => ({value: item.Id, label: item.Descripcion})) || []
        setRooms(roomsData)
      } else if (tipoBusqueda === 'ocupadas') {
        const response = await getHabitacionesByEstadoService({
          CampamentoId: campamentoId,
          ModuloId: moduloId,
        })
        const roomsData =
          response.data.data?.lstHabitaciones?.map((item: any) => ({
            value: item.habitacionId || item.habitacionId,
            label: item.codigoHabitacion || item.codigoHabitacion,
            ...item,
          })) || []
        setRooms(roomsData)
      } else if (tipoBusqueda === 'relevo') {
        const response = await getRoomRelevoService({
          moduleId: moduloId,
          relevoId: relevoId || relevoIdAux || '',
          campamentoId: campamentoId || '',
        })
        const roomsData =
          response.data.data?.map((item: any) => ({
            value: item.id,
            label: item.codigo,
            ...item,
          })) || []
        if (roomsData.length > 0) {
          setValue('HabitacionId', roomsData[0].value)
          await getBeds(campamentoId, roomsData[0].value, 'relevo', relevoId || relevoIdAux)
        }
        setRooms(roomsData)
      }
    } catch (error) {
      setRooms([])
    }
  }

  const getBeds = async (
    campamentoId: string,
    habitacionId: string,
    tipoBusqueda: 'disponibles' | 'ocupadas' | 'relevo',
    relevoIdAux?: string,
  ) => {
    try {
      if (tipoBusqueda === 'disponibles') {
        const response = await getCamasDisponibleService({
          habitacionId: habitacionId,
        })
        // const bedsData =
        //   response.data.data?.map((item) => ({value: item.Id, label: item.Descripcion, ...item})) ||
        //   []
        const bedsData =
          response.data.data?.map((item) => ({
            value: item.Descripcion,
            label: item.Descripcion,
            ...item,
          })) || []
        setBeds(bedsData)
      } else if (tipoBusqueda === 'ocupadas') {
        const response = await getCamasByEstadoService({
          CampamentoId: campamentoId,
          HabitacionId: habitacionId,
        })
        // const bedsData =
        //   response.data.data?.lstCamas?.map((item: any) => ({
        //     value: item.camaId || item.camaId,
        //     label: item.codigoCama || item.codigoCama,
        //     ...item,
        //   })) || []
        const bedsData =
          response.data.data?.lstCamas?.map((item: any) => ({
            value: item.codigoCama || item.camaId,
            label: item.codigoCama || item.codigoCama,
            ...item,
          })) || []
        setBeds(bedsData)
      } else if (tipoBusqueda === 'relevo') {
        const response = await getBedRelevoService({
          habitacionId: habitacionId,
          relevoId: relevoId || relevoIdAux || '',
          campamentoId: campamentoId || '',
        })
        const bedsData =
          response.data.data?.map((item: any) => ({
            value: item.codigo,
            label: item.codigo,
            ...item,
          })) || []
        // const bedsData =
        //   response.data.data?.map((item: any) => ({
        //     value: item.id,
        //     label: item.codigo,
        //     ...item,
        //   })) || []
        setBeds(bedsData)
        console.log('bedsData', bedsData)
        if (bedsData.length > 0) {
          setValue('CamaId', bedsData[0].id)
          // setValue('CamaIdFake', bedsData[0].value)
          setValue('CamaCalienteId', bedsData[0].camaCalienteId || null)
        }
      }
    } catch (error) {
      setBeds([])
    }
  }

  const getStatusFn = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHuesped',
      })
      if (!response.data.error && response.data.data) {
        const mappedData = response.data.data.map((item: any) => ({
          value: item.id,
          label: item.nombreCorto || item.nombreLargo,
        }))
        setStatus(mappedData)
      }
    } catch (error) {
      console.error('Error getting status list:', error)
    }
  }

  const getCargosFn = async () => {
    try {
      const response = await getListCargosService()
      if (!response.data.error && response.data.data) {
        const mappedData = response.data.data.map((item: any) => ({
          value: item.Id,
          label: item.NombreCorto || item.NombreLargo,
        }))
        const allData = [{value: '', label: 'CUALQUIERA'}, ...mappedData]
        setCargos(allData)
      }
    } catch (error) {
      console.error('Error getting cargos:', error)
      setCargos([{value: '', label: 'CUALQUIERA'}])
    }
  }

  const handleStatusChange = async (value: any) => {
    const newStatusId = value ? value.value : ''

    if (
      previousStatusId !== null &&
      previousStatusId !== '' &&
      newStatusId !== previousStatusId &&
      huespedId
    ) {
      const statusLabel = value ? value.label : ''
      const result = await Swal.fire({
        title: 'Asignar status',
        text: `¿Quieres asignarle el status "${statusLabel}" al huésped?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        confirmButtonColor: 'var(--kt-primary)',
        allowOutsideClick: false,
      })

      if (result.isConfirmed) {
        // Actualizar el modal existente para mostrar el loader sin ocultar la información
        Swal.update({
          title: 'Asignando status...',
          html: `<div>¿Quieres asignarle el status "${statusLabel}" al huésped?</div>`,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        Swal.showLoading()

        try {
          const response = await updateTipoHuespedGuestService({
            Id: huespedId,
            TipoHuespedId: newStatusId,
          })

          // Cerrar el modal
          Swal.close()

          if (!response.data.error) {
            getSnackBarToast('Status asignado al huésped con éxito', 'success')
            setPreviousStatusId(newStatusId)
          } else {
            getSnackBarToast(response.data.message, 'error')
            // Revertir el cambio si falla
            setValue('TipoHuespedId', previousStatusId || '')
          }
        } catch (error: any) {
          // Cerrar el modal
          Swal.close()
          getSnackBarToast(error?.response?.data?.message || 'Error al asignar status', 'error')
          // Revertir el cambio si falla
          setValue('TipoHuespedId', previousStatusId || '')
        }
      } else {
        // Si cancela, revertir el cambio
        setValue('TipoHuespedId', previousStatusId || '')
      }
    } else {
      // Si no hay status anterior o no hay huésped, solo actualizar
      setPreviousStatusId(newStatusId)
    }
  }

  const handleCargoChange = async (value: any) => {
    const newCargoId = value ? value.value : ''

    // Si hay un cargo anterior y es diferente al nuevo, mostrar modal de confirmación
    if (
      previousCargoId !== null &&
      previousCargoId !== '' &&
      newCargoId !== previousCargoId &&
      huespedId
    ) {
      const cargoLabel = value ? value.label : ''
      const result = await Swal.fire({
        title: 'Asignar Cargo',
        text: `¿Quieres asignarle el cargo "${cargoLabel}" al huésped?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        confirmButtonColor: 'var(--kt-primary)',
        allowOutsideClick: false,
      })

      if (result.isConfirmed) {
        // Actualizar el modal existente para mostrar el loader sin ocultar la información
        Swal.update({
          title: 'Asignando cargo...',
          html: `<div>¿Quieres asignarle el cargo "${cargoLabel}" al huésped?</div>`,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        Swal.showLoading()

        try {
          const response = await updateCargoGuestService({
            Id: huespedId,
            CargoId: newCargoId,
          })

          // Cerrar el modal
          Swal.close()

          if (!response.data.error) {
            getSnackBarToast('Cargo asignado al huésped con éxito', 'success')
            setPreviousCargoId(newCargoId)
          } else {
            getSnackBarToast(response.data.message, 'error')
            // Revertir el cambio si falla
            setValue('CargoId', previousCargoId || '')
          }
        } catch (error: any) {
          // Cerrar el modal
          Swal.close()
          getSnackBarToast(error?.response?.data?.message || 'Error al asignar cargo', 'error')
          // Revertir el cambio si falla
          setValue('CargoId', previousCargoId || '')
        }
      } else {
        // Si cancela, revertir el cambio
        setValue('CargoId', previousCargoId || '')
      }
    } else {
      // Si no hay cargo anterior o no hay huésped, solo actualizar
      setPreviousCargoId(newCargoId)
    }
  }

  const handleCargoCreated = (cargoId?: string) => {
    getCargosFn()
    // Si se creó un cargo y hay un huésped seleccionado, establecer el cargo en el select
    if (cargoId && huespedId) {
      setValue('CargoId', cargoId)
      setPreviousCargoId(cargoId)
    }
  }

  const handleSelectGuestFromModal = async (guest: any) => {
    try {
      // Obtener los datos completos del huésped
      const response = await getGuestByIdService(guest.HuespedId)
      if (!response.data.error && response.data.data) {
        const guestData = response.data.data
        const guestOption = {
          value: guestData.Id,
          label: `${guestData.Nombres || ''} ${guestData.ApellidoPaterno || ''} ${
            guestData.ApellidoMaterno || ''
          }`.trim(),
          Nombres: guestData.Nombres,
          ApellidoPaterno: guestData.ApellidoPaterno,
          ApellidoMaterno: guestData.ApellidoMaterno,
          NumeroDocumento: guestData.NumeroDocumento,
          UsuarioId: guestData.UsuarioId,
          TipoHuesped: guestData.TipoHuespedId,
          EmpresaSubContratista:
            (guestData as any).EmpresaSubContratista || (guestData as any).EmpresaContratista || '',
          CargoId: guestData.CargoId,
          cargoId: guestData.CargoId,
        }
        await handleGuestChange(guestOption)
      }
    } catch (error) {
      console.error('Error selecting guest from modal:', error)
      getSnackBarToast('Error al cargar los datos del huésped', 'error')
    }
  }

  const handleSelectBedFromModal = async (bed: any) => {
    try {
      if (bed.CamaId) {
        // Establecer los valores del módulo, habitación y cama
        if (bed.ModuloId) {
          setValue('ModuloId', bed.ModuloId)
          await getRooms(campamentoId, bed.ModuloId, tipoBusqueda)
        }
        if (bed.HabitacionId) {
          setValue('HabitacionId', bed.HabitacionId)
          await getBeds(campamentoId, bed.HabitacionId, tipoBusqueda)
        }
        if (bed.CamaId) {
          setValue('CamaId', bed.CamaId)
        }
      }
    } catch (error) {
      console.error('Error selecting bed from modal:', error)
    }
  }

  const handleCampChange = (value: any) => {
    setValue('ModuloId', '')
    setValue('HabitacionId', '')
    setValue('CamaId', '')
    setValue('CamaIdFake', '')
    setValue('HuespedId', '')
    setValue('NombresCompletos', '')
    setValue('NumeroDocumento', '')
    setValue('UsuarioId', '')
    setValue('StatusId', '')
    setValue('TipoHuespedId', '')
    setValue('CargoId', '')
    setValue('EmpresaContratista', '')
    setValue('nameGuest', '')
    setValue('isRelevo', false)
    setValue('hasRelevoCompleteData', false)
    setValue('relevoId', '')
    setValue('RelevoDataResponse', null)
    setValue('Disponibles', false)
    setValue('Ocupadas', false)
    setValue('bedStatus', '')
    setPreviousCargoId(null)
    setPreviousStatusId(null)
  }

  const handleModuleChange = async (value: any) => {
    setValue('HabitacionId', '')
    setValue('CamaId', '')
    setValue('CamaIdFake', '')
    // await getRoomsList(value.value, campamentoId, relevoId || null)
    await getRooms(campamentoId, value.value, tipoBusqueda)
  }

  const handleRoomChange = async (value: any) => {
    setValue('CamaId', '')
    // await getBedsList(value.value, campamentoId, relevoId || null)
    await getBeds(campamentoId, value.value, tipoBusqueda)
  }

  // const getUltimaCamaUsadaDisponibleAndSetValues = async () => {
  //   try {
  //     const dto = {
  //       HuespedId: watch('HuespedId'),
  //     }
  //     const response = await getUltimaCamaUsadaDisponibleService(dto)
  //     if (response.data.data && !response.data.error) {
  //       const data = response.data.data
  //       getModules(campamentoId, 'disponibles')
  //       if (data.moduloId) {
  //         await setValue('ModuloId', data.moduloId)
  //         await getRooms(campamentoId, data.moduloId, 'disponibles')
  //         await setValue('HabitacionId', data.habitacionId)
  //         await getBeds(campamentoId, data.habitacionId, 'disponibles')
  //         await setValue('CamaId', data.camaId)
  //       }
  //     } else {
  //       await setValue('ModuloId', '')
  //       await setValue('HabitacionId', '')
  //       await setValue('CamaId', '')
  //     }
  //   } catch (error) {
  //     console.error('Error getting ultima cama usada disponible:', error)
  //     await setValue('ModuloId', '')
  //     await setValue('HabitacionId', '')
  //     await setValue('CamaId', '')
  //   }
  // }

  const getCamaOcupadaPorHuespedAndSetValues = async (huespedId: string) => {
    try {
      const dto = {
        HuespedId: huespedId,
      }
      const response = await getCamaOcupadaPorHuespedService(dto)
      if (response.data.data && !response.data.error) {
        const data = response.data.data
        if (data.moduloId || data.ModuloId) {
          setValue('tipoBusqueda', 'ocupadas')
          getModules(campamentoId, 'ocupadas')
          await setValue('ModuloId', data.moduloId || data.ModuloId)
          await getRooms(campamentoId, data.moduloId || data.ModuloId, 'ocupadas')
          await setValue('HabitacionId', data.habitacionId || data.HabitacionId)
          await getBeds(campamentoId, data.habitacionId || data.HabitacionId, 'ocupadas')
          await setValue('CamaId', data.camaId || data.CamaId)
          await setValue('CamaCalienteId', data.camaCalienteId || null)
        }
      } else {
        // setTipoBusqueda('disponibles')
        getModules(campamentoId, 'disponibles')
        setValue('tipoBusqueda', 'disponibles')
        await setValue('ModuloId', '')
        await setValue('HabitacionId', '')
        await setValue('CamaId', '')
        await setValue('CamaCalienteId', '')
      }
    } catch (error) {
      console.error('Error getting cama ocupada por huesped:', error)
      await setValue('ModuloId', '')
      await setValue('HabitacionId', '')
      await setValue('CamaId', '')
      await setValue('CamaCalienteId', '')
    }
  }

  // Función para obtener el estado de la cama
  const getEstadoCama = async (camaId: string) => {
    if (camaId && campamentoId) {
      // const camaSeleccionada = beds.find((cama) => cama.value === camaIdFake)
      // const camaCalienteId = camaSeleccionada?.CamaCalienteId || camaSeleccionada?.camaCalienteId
      // if (camaSeleccionada) {
      //   setValue('camaCalienteId', camaCalienteId || null)
      // }
      try {
        setValue('HuespedNombreOcupada', '')
        const requestData: any = {
          camaId: camaId,
          camaCalienteId: camaCalienteId || null,
        }
        // Si es relevo, agregar RelevoId
        if (isRelevo && relevoId) {
          requestData.RelevoId = relevoId
        }
        const response = await getEstadoCamaService(requestData)
        if (response.data.data) {
          const estadoData: any = response.data.data
          const estado =
            estadoData.EstadoCama || estadoData.estadoCama || estadoData.EstadoCama_descripcion

          setValue('bedStatus', estado)
          if (estado !== 'DISPONIBLE') {
            setValue(
              'HuespedNombreOcupada',
              estadoData.HuespedNombre || estadoData.huespedNombre || '',
            )
            setValue('CheckOutRelevo', true)
            setValue('checkout', true)
            setValue('checkout_reservaId', estadoData.ReservaId)
            setValue('checkout_camaId', camaId)
            setValue('checkout_huespedId', estadoData.HuespedId)
            setValue('checkout_estadocama', estadoData.estadoCama)
            setValue('checkout_reservacamaId', estadoData.ReservaCamaId)
            setBedInfo({
              huespedNombre: estadoData.HuespedNombre || '',
              nroReserva: estadoData.NroReserva || '',
              fechaFinProgramada: estadoData.FechaFinProgramada || '',
            })
          } else {
            setValue('HuespedNombreOcupada', '')
            setValue('CheckOutRelevo', false)
            setValue('checkout', false)
          }
        }
      } catch (error) {
        console.error('Error getting estado cama:', error)
        // En caso de error, usar el estado por defecto
        setValue('bedStatus', 'DISPONIBLE')
        setValue('HuespedNombreOcupada', '')
      }
    }
  }

  const loadOptionsGuest = useCallback(
    async (inputValue: string) => {
      try {
        if (inputValue.length < 3 || !campamentoId) {
          return []
        }
        const isValidDni = /^\d{8}$/.test(inputValue)
        const request = {
          campamentoId: campamentoId,
          nroDoc: inputValue,
        }
        const response = await getListComboHuespedService(request)
        const data = response.data.data || []
        // Si no hay resultados, mostrar modal para crear huésped
        if (data.length === 0 && isValidDni) {
          showModalPopup(inputValue)
          return []
        }
        const mappedGuest = data?.map((item: any) => ({
          value: item.Id,
          label: `${item.Nombres || ''} ${item.ApellidoPaterno || ''} ${
            item.ApellidoMaterno || ''
          } (${item.NumeroDocumento || ''})`,
          ...item,
        }))
        return mappedGuest || []
      } catch (error) {
        console.error('Error fetching guest options:', error)
        return []
      }
    },
    [campamentoId],
  )

  const loadOptionsGuestRelevo = useCallback(
    async (inputValue: string) => {
      try {
        if (inputValue.length < 3 || !campamentoId) {
          return []
        }
        const isValidDni = /^\d{8}$/.test(inputValue)
        const request = {
          campamentoId: campamentoId,
          nroDoc: inputValue,
        }
        const response = await getListComboHuespedService(request)
        const data = response.data.data || []
        // Si no hay resultados, mostrar modal para crear huésped
        if (data.length === 0 && isValidDni) {
          showModalPopup(inputValue)
          return []
        }
        const mappedGuest = data?.map((item: any) => ({
          value: item.Id,
          label: `${item.Nombres || ''} ${item.ApellidoPaterno || ''} ${
            item.ApellidoMaterno || ''
          } (${item.NumeroDocumento || ''})`,
          ...item,
        }))
        return mappedGuest || []
      } catch (error) {
        console.error('Error fetching guest options:', error)
        return []
      }
    },
    [campamentoId],
  )

  const handleGuestChange = async (selectedGuest: any) => {
    if (selectedGuest) {
      setValue('ModuloId', '')
      setValue('HabitacionId', '')
      setValue('CamaId', '')
      setValue('CamaIdFake', '')
      setValue('CamaCalienteId', '')
      setValue('HuespedId', selectedGuest.value)
      setValue('UsuarioId', selectedGuest.UsuarioId)
      setValue('NumeroDocumento', selectedGuest.NumeroDocumento || '')
      setValue('StatusId', selectedGuest.TipoHuesped)
      setValue('TipoHuespedId', selectedGuest.TipoHuespedId)
      setValue('EmpresaContratista', selectedGuest.EmpresaSubContratista)
      const nombreCompleto = `${selectedGuest.Nombres || ''} ${
        selectedGuest.ApellidoPaterno || ''
      } ${selectedGuest.ApellidoMaterno || ''}`.trim()
      setValue('NombresCompletos', nombreCompleto)

      // Inicializar el cargo del huésped si existe
      const cargoId = selectedGuest.CargoId || selectedGuest.cargoId || ''
      setValue('CargoId', cargoId || '')
      setPreviousCargoId(cargoId || '')

      try {
        const request = {
          huespedId: selectedGuest.value,
          fechaini: fechaInicio ? moment(fechaInicio).format('YYYY-MM-DD') : null,
          fechafin: fechaFin ? moment(fechaFin).format('YYYY-MM-DD') : null,
        }
        const response = await getHuespedEsRelevoService(request)
        if (!response.data.error) {
          const relevoDataResponse: any = response.data.data
          const relevoIdValue = relevoDataResponse.relevoId || relevoDataResponse.RelevoId

          // Guardar la respuesta completa en el formulario para no consultar el servicio nuevamente
          setValue('isRelevo', !!relevoIdValue)
          setValue('RelevoDataResponse', relevoDataResponse)

          if (relevoIdValue) {
            setValue('isRelevo', true)
            setValue('relevoId', String(relevoIdValue))

            // Verificar si tiene todos los datos completos
            const hasCompleteData =
              relevoDataResponse.moduloId_ocu &&
              relevoDataResponse.habitacionId_ocu &&
              relevoDataResponse.camaId_ocu &&
              relevoDataResponse.huespedNombre_ocu

            // setHasRelevoCompleteData(hasCompleteData)
            setValue('HasRelevoCompleteData', hasCompleteData)

            if (hasCompleteData) {
              // Si tiene datos completos, bloquear ambos checks y usar servicios de relevo
              setValue('Disponibles', false)
              setValue('Ocupadas', true)
              setValue('tipoBusqueda', 'ocupadas')
              await getModules(campamentoId, 'ocupadas')
              await setValue('ModuloId', relevoDataResponse.moduloId_ocu)
              await getRooms(campamentoId, relevoDataResponse.moduloId_ocu, 'ocupadas')
              await setValue('HabitacionId', relevoDataResponse.habitacionId_ocu)
              await getBeds(campamentoId, relevoDataResponse.habitacionId_ocu, 'ocupadas')
              await setValue('CamaId', relevoDataResponse.camaId_ocu)
              await setValue('CamaCalienteId', relevoDataResponse.camaCalienteId || null)
              setValue('nameGuest', relevoDataResponse.huespedNombre_ocu)
            } else {
              // Si solo tiene relevoId, usar servicios de relevo para cargar módulos
              setValue('Disponibles', true)
              setValue('Ocupadas', false)
              setValue('tipoBusqueda', 'relevo')
              // Llamar a getModuleRelevoService cuando hay relevoId

              await getModules(campamentoId, 'relevo', String(relevoIdValue))

              // const dto = {
              //   HuespedId: watch('HuespedId'),
              // }
              // const {data} = await getUltimaCamaUsadaDisponibleService(dto)
              // const ultimaCamaData = data.data
              // if (!ultimaCamaData.estado) {
              //   setValue('tipoBusqueda', 'relevo')
              //   await getModules(campamentoId, 'relevo', String(relevoIdValue))
              // } else if (ultimaCamaData.estado === 'OCU') {
              //   setValue('tipoBusqueda', 'ocupadas')
              //   await getModules(campamentoId, 'ocupadas')
              //   setValue('ModuloId', ultimaCamaData.moduloId)
              //   await getRooms(campamentoId, ultimaCamaData.moduloId, 'ocupadas')
              //   setValue('HabitacionId', ultimaCamaData.habitacionId)
              //   await getBeds(campamentoId, ultimaCamaData.habitacionId, 'ocupadas')
              //   setValue('CamaId', ultimaCamaData.camaId)
              // } else {
              //   setValue('tipoBusqueda', 'disponibles')
              //   await getModules(campamentoId, 'disponibles')
              //   setValue('ModuloId', ultimaCamaData.moduloId)
              //   await getRooms(campamentoId, ultimaCamaData.moduloId, 'disponibles')
              //   setValue('HabitacionId', ultimaCamaData.habitacionId)
              //   await getBeds(campamentoId, ultimaCamaData.habitacionId, 'disponibles')
              //   setValue('CamaId', ultimaCamaData.camaId)
              // }
            }
          } else {
            setValue('bedStatus', '')
            setValue('isRelevo', false)
            setValue('relevoId', null)
            // setHasRelevoCompleteData(false)
            setValue('hasRelevoCompleteData', false)
            setValue('relevoId', '')
            setValue('isRelevo', false)
            setValue('RelevoDataResponse', null)
            setValue('Disponibles', false)
            setValue('Ocupadas', false)
            setValue('tipoBusqueda', 'disponibles')
            const dto = {
              HuespedId: watch('HuespedId'),
            }
            const {data} = await getUltimaCamaUsadaDisponibleService(dto)
            const ultimaCamaData = data.data
            if (!ultimaCamaData.estado) {
              setValue('tipoBusqueda', 'disponibles')
              await getModules(campamentoId, 'disponibles')
            } else if (ultimaCamaData.estado === 'OCU') {
              setValue('tipoBusqueda', 'ocupadas')
              await getModules(campamentoId, 'ocupadas')
              setValue('ModuloId', ultimaCamaData.moduloId)
              await getRooms(campamentoId, ultimaCamaData.moduloId, 'ocupadas')
              setValue('HabitacionId', ultimaCamaData.habitacionId)
              await getBeds(campamentoId, ultimaCamaData.habitacionId, 'ocupadas')
              setValue('CamaId', ultimaCamaData.camaId)
              setValue('CamaCalienteId', ultimaCamaData.camaCalienteId || null)
            } else {
              setValue('tipoBusqueda', 'disponibles')
              await getModules(campamentoId, 'disponibles')
              setValue('ModuloId', ultimaCamaData.moduloId)
              await getRooms(campamentoId, ultimaCamaData.moduloId, 'disponibles')
              setValue('HabitacionId', ultimaCamaData.habitacionId)
              await getBeds(campamentoId, ultimaCamaData.habitacionId, 'disponibles')
              setValue('CamaId', ultimaCamaData.camaId)
              setValue('CamaCalienteId', ultimaCamaData.camaCalienteId || null)
            }
          }
        } else {
          // Si no hay data, asumimos que no es relevo
          setValue('isRelevo', false)

          setValue('relevoId', null)
          setValue('hasRelevoCompleteData', false)
          setValue('relevoId', '')
          setValue('isRelevo', false)
          setValue('RelevoDataResponse', null)
          setValue('Disponibles', true)
          setValue('Ocupadas', false)
          setValue('tipoBusqueda', 'disponibles')
          getSnackBarToast(response.data.message, 'warning')
          reset({
            CampamentoId: campamentoId || '',
            FechaInicio: moment().format('YYYY-MM-DD'),
            FechaFin: moment().format('YYYY-MM-DD'),
            NumeroDocumento: '',
            StatusId: '',
            ModuloId: '',
            HabitacionId: '',
            CamaId: '',
            EmpresaContratista: '',
            CheckOutRelevo: false,
            OtrasHabitacionesDisponibles: false,
            ReservaYCheckin: true,
            Impresion: true,
            HuespedId: '',
            NombresCompletos: '',
            HuespedRelevoId: '',
            HuespedRelevoNombre: '',
            VolverRelevo: false,
            HabilitarHuespedRelevo: false,
            // Campos para guardar la respuesta de getHuespedEsRelevoService
            RelevoDataResponse: null,
            checkout: false,
            checkout_reservaId: null,
            checkout_camaId: null,
            checkout_huespedId: null,
            checkout_estadocama: null,
            checkout_reservacamaId: null,
            //variables de apoyo
            bedStatus: '',
            nameGuest: '',
            isRelevo: false,
            relevoId: null,
            hasRelevoCompleteData: false,
            HuespedNombreOcupada: '',
            tipoBusqueda: '',
            HuespedRelevoTieneRelevo: false,
            loadingVolverRelevo: true,
          })

          // No es relevo, usar GetUltimaCamaUsadaDisponible en lugar de pseudo
        }
      } catch (error) {
        console.error('Error checking relevo status:', error)
        setValue('isRelevo', false)
        setValue('hasRelevoCompleteData', false)
        setValue('relevoId', '')
        setValue('isRelevo', false)
        setValue('RelevoDataResponse', null)
        setValue('Disponibles', true)
        setValue('Ocupadas', false)
        setValue('tipoBusqueda', 'disponibles')
        setValue('bedStatus', '')
      }
    } else {
      setValue('HuespedId', '')
      setValue('NombresCompletos', '')
      setValue('isRelevo', false)
      setValue('hasRelevoCompleteData', false)
      setValue('relevoId', '')
      setValue('isRelevo', false)
      setValue('RelevoDataResponse', null)
      setValue('Disponibles', false)
      setValue('Ocupadas', false)
    }
  }

  const handleGuestRelevoChange = async (selectedGuest: any) => {
    if (selectedGuest) {
      setValue('HuespedRelevoId', selectedGuest.value)
      setValue('UsuarioIdRelevo', selectedGuest.UsuarioId)
      setValue('VolverRelevo', false)
      setValue('loadingVolverRelevo', true)
      setValue(
        'HuespedRelevoNombre',
        `${selectedGuest.Nombres || ''} ${selectedGuest.ApellidoPaterno || ''} ${
          selectedGuest.ApellidoMaterno || ''
        }`.trim(),
      )
      setValue('HuespedRelevoNumeroDocumento', selectedGuest.NumeroDocumento || '')

      // Llamar al servicio getGrupoByUsuario cuando se selecciona un huésped relevo
      try {
        const response = await getGrupoByUsuario(selectedGuest.UsuarioId)
        if (response.data.data) {
          await getCamaOcupadaPorHuespedAndSetValues(selectedGuest.value)
          setValue('HuespedRelevoTieneRelevo', true) // Campo para validar en el onSubmit
        } else {
          await getCamaOcupadaPorHuespedAndSetValues(selectedGuest.value)
          setValue('VolverRelevo', false)
          setValue('HuespedRelevoTieneRelevo', false)
        }
      } catch (error) {
        console.error('Error obteniendo grupo por usuario:', error)
        setValue('HuespedRelevoTieneRelevo', false)
      } finally {
        setValue('loadingVolverRelevo', false)
      }
    } else {
      setValue('HuespedRelevoId', '')
      setValue('HuespedRelevoNombre', '')
      setValue('relevoId', '')
      setValue('HuespedRelevoTieneRelevo', false)
    }
  }

  const handleGuestCreated = async (guest: GuestModel) => {
    const guestOption = {
      value: guest.Id,
      label: `${guest.Nombres || ''} ${guest.ApellidoPaterno || ''} ${
        guest.ApellidoMaterno || ''
      } (${guest.NumeroDocumento || ''})`,
      ...guest,
    }
    await handleGuestChange(guestOption)
    setShowModalCreateGuest(false)
    setPendingDocumento(null)
  }

  const handleTipoBusquedaChange = async (tipo: 'disponibles' | 'ocupadas') => {
    setValue('tipoBusqueda', tipo)
    setValue('Disponibles', tipo === 'disponibles')
    setValue('Ocupadas', tipo === 'ocupadas')
    // Limpiar selecciones y recargar listas
    setValue('ModuloId', '')
    setValue('HabitacionId', '')
    setValue('CamaId', '')
    setValue('CamaIdFake', '')
    setModules([])
    setRooms([])
    setBeds([])
    if (watch('HuespedId')) {
      let dataType = tipo === 'disponibles' ? 'DIS' : 'OCU'
      setValueChangeTypeSearch(dataType)
    }
  }

  const handleBedChange = async (value: any) => {
    let camaCalienteId = value ? value.CamaCalienteId || value.camaCalienteId || null : null
    setValue('CamaCalienteId', camaCalienteId)
    // setValue('CamaIdFake', value ? value.value : '')
    if (tipoBusqueda === 'disponibles') {
      setValue('CamaId', value ? value.Id : '')
    } else if (tipoBusqueda === 'ocupadas') {
      setValue('CamaId', value ? value.camaId : '')
    } else if (tipoBusqueda === 'relevo') {
      setValue('CamaId', value ? value.id : '')
    }
  }

  const setValueChangeTypeSearch = async (tipo: string) => {
    try {
      const dto = {
        HuespedId: watch('HuespedId'),
      }
      const response = await getUltimaCamaUsadaDisponibleService(dto)
      if (response.data.data && !response.data.error) {
        const data = response.data.data
        if (data.estado !== tipo) {
          if (tipo === 'DIS') {
            setValue('tipoBusqueda', 'disponibles')
            await getModules(campamentoId, 'disponibles')
          } else if (tipo === 'OCU') {
            setValue('tipoBusqueda', 'ocupadas')
            await getModules(campamentoId, 'ocupadas')
          }
          return
        }
        if (data.estado === 'OCU') {
          setValue('tipoBusqueda', 'ocupadas')
          await getModules(campamentoId, 'ocupadas')
          setValue('ModuloId', data.moduloId)
          await getRooms(campamentoId, data.moduloId, 'ocupadas')
          setValue('HabitacionId', data.habitacionId)
          await getBeds(campamentoId, data.habitacionId, 'ocupadas')
          setValue('CamaId', data.camaId)
          setValue('CamaCalienteId', data.camaCalienteId || null)
        } else if (data.estado === 'DISPONIBLE') {
          setValue('tipoBusqueda', 'disponibles')
          await getModules(campamentoId, 'disponibles')
          setValue('ModuloId', data.moduloId)
          await getRooms(campamentoId, data.moduloId, 'disponibles')
          setValue('HabitacionId', data.habitacionId)
          await getBeds(campamentoId, data.habitacionId, 'disponibles')
          setValue('CamaId', data.camaId)
          setValue('CamaCalienteId', data.camaCalienteId || null)
        } else {
          setValue('tipoBusqueda', 'disponibles')
          await getModules(campamentoId, 'disponibles')
          setValue('ModuloId', data.moduloId)
          await getRooms(campamentoId, data.moduloId, 'disponibles')
          setValue('HabitacionId', data.habitacionId)
          await getBeds(campamentoId, data.habitacionId, 'disponibles')
          setValue('CamaId', data.camaId)
          setValue('CamaCalienteId', data.camaCalienteId || null)
        }
      } else {
        await setValue('ModuloId', '')
        await setValue('HabitacionId', '')
        await setValue('CamaId', '')
      }
    } catch (error) {
      console.error('Error getting ultima cama usada disponible:', error)
      await setValue('ModuloId', '')
      await setValue('HabitacionId', '')
      await setValue('CamaId', '')
    }
  }

  const showModalPopup = (inputValue: string) => {
    Swal.fire({
      title: 'Crear Huésped',
      text: 'Este numero de documento no está registrado. ¿Desea crear un nuevo huésped?',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, crear',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const tipoDoc = '01' // Por defecto DNI
        setPendingDocumento({numero: inputValue, tipo: tipoDoc})
        setShowModalCreateGuest(true)
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  return (
    <div className='sdx_form container-fluid p-4'>
      <h4 className='mb-4'>Datos de la Reserva</h4>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Nombre Campamento'
            name='CampamentoId'
            data={camps}
            onChangeValue={handleCampChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <InputNumberWrapper2
            labelText='Dias'
            name='dias'
            textPlaceholder='Escribe los dias'
            required
            min={0}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <InputDateWrapper
            labelText='Fecha de Inicio'
            name='FechaInicio'
            minValue={moment().format('YYYY-MM-DD')}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <InputDateWrapper
            labelText='Fecha de Fin'
            name='FechaFin'
            minValue={moment().format('YYYY-MM-DD')}
          />
        </div>
      </div>

      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectAsyncWrapper
            labelText='Nro Documento de Identidad'
            name='HuespedId'
            loadOptions={loadOptionsGuest}
            disabled={!campamentoId}
            onChangeValue={handleGuestChange}
            textPlaceholder=''
            value={
              huespedId
                ? {
                    value: huespedId,
                    label: `${watch('NombresCompletos') || ''} (${watch('NumeroDocumento') || ''})`,
                  }
                : null
            }
          />
        </div>
        {watch('NombresCompletos') && (
          <div className='mb-2 col-sm-12 col-lg-4 d-flex flex-column align-items-start  justify-content-center'>
            <label className='fw-bold fs-5'>NOMBRES COMPLETOS DEL USUARIO</label>
            <div className='mt-2 d-flex align-items-center'>
              <span className='fw-normal'>
                {watch('NombresCompletos')} - {watch('NumeroDocumento')}
              </span>
              <a
                onClick={() => setShowModalLastBeds(true)}
                title='Ver últimas camas'
                className={clsx('ms-2 text-decoration-underline  fs-8', {
                  'cursor-pointer': !camaId || !huespedId,
                })}
              >
                Ver últimas camas
              </a>
              {/* <button
                type='button'
                className='btn btn-icon btn-sm btn-light-primary mb-2 ms-2'
                onClick={() => setShowModalLastBeds(true)}
                title='Ver últimas camas'
                disabled={!camaId || !huespedId}
              >

                <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-2' />
              </button> */}
            </div>
            {camaConfigurada && (
              <span className='badge fs-6 badge-success mt-2'>
                Cama Permanente (Proceso Relevos)
              </span>
            )}
          </div>
        )}

        {huespedId && (
          <>
            <div className='mb-2 col-sm-12 col-lg-2'>
              <SelectWrapper
                labelText='Status'
                name='TipoHuespedId'
                data={status}
                onChangeValue={handleStatusChange}
              />
            </div>
            <div className='mb-2 col-sm-12 col-lg-3 d-flex align-items-end'>
              <div className='flex-grow-1 w-60'>
                <SelectWrapper
                  labelText='Cargo'
                  name='CargoId'
                  data={cargos}
                  onChangeValue={handleCargoChange}
                />
              </div>
              <button
                type='button'
                className='btn btn-icon btn-sm btn-light-primary mb-2'
                onClick={() => setShowModalCreateCargo(true)}
                title='Crear nuevo cargo'
              >
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-2' />
              </button>
            </div>
          </>
        )}
      </div>

      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Empresa Contratista'
            name='EmpresaContratista'
            textPlaceholder='Placeholder'
            disabled={true}
          />
        </div>
        {nameGuest && (
          <div className='mb-2 col-sm-12 col-lg-5 d-flex flex-column align-items-start justify-content-center'>
            <label className='fw-bold fs-5'>Huesped Relevo</label>
            <div className='mt-2'>
              <span className='fw-normal'>{nameGuest}</span>
            </div>
          </div>
        )}
      </div>
      <h4 className='mb-4'>Datos de Relevo</h4>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3 d-flex align-items-center'>
          <CheckWrapper
            name='HabilitarHuespedRelevo'
            labelText='Habilitar Huésped Relevo'
            onchange={(e: any) => {
              const checked = e.target.checked
              if (!checked) {
                // Si se desmarca, limpiar el campo
                setValue('HuespedRelevoId', '')
                setValue('HuespedRelevoNombre', '')
                setValue('HuespedRelevoTieneRelevo', false)
              }
            }}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectAsyncWrapper
            labelText='Nro Documento de Identidad - Relevo'
            name='HuespedRelevoId'
            loadOptions={loadOptionsGuestRelevo}
            disabled={!habilitarHuespedRelevo}
            onChangeValue={handleGuestRelevoChange}
            textPlaceholder=''
            value={
              huespedRelevoId
                ? {
                    value: huespedRelevoId,
                    label: `${watch('HuespedRelevoNombre') || ''} (${
                      watch('HuespedRelevoNumeroDocumento') || ''
                    })`,
                  }
                : null
            }
          />
        </div>
        {watch('HuespedRelevoNombre') && (
          <div className='mb-2 col-sm-12 col-lg-4 d-flex flex-column align-items-start justify-content-center'>
            <label className='fw-bold fs-5'>NOMBRES COMPLETOS DEL HUÉSPED RELEVO</label>
            <div className='mt-2'>
              <span className='fw-normal me-6'>
                {watch('HuespedRelevoNombre')} - {watch('HuespedRelevoNumeroDocumento')}
              </span>
              {huespedRelevoTieneRelevo && (
                <span className={clsx('badge fs-6', 'badge-success')}>RELEVO</span>
              )}
            </div>
          </div>
        )}

        <div className='mb-2 col-sm-12 col-lg-2 d-flex align-items-center'>
          <CheckWrapper
            name='VolverRelevo'
            labelText='Volver Relevo'
            disabled={!watch('HuespedRelevoId') || huespedRelevoTieneRelevo || loadingVolverRelevo}
          />
        </div>
      </div>
      <h4 className='mb-4'>Datos de Cama</h4>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Nomenclatura Módulo'
            name='ModuloId'
            data={modules}
            onChangeValue={handleModuleChange}
            // disabled={buttonsDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Nomenclatura Habitación'
            name='HabitacionId'
            data={rooms}
            onChangeValue={handleRoomChange}
            // disabled={buttonsDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3 d-flex align-items-end'>
          <div className='flex-grow-1'>
            <SelectWrapper
              labelText={ 
                <span className='d-inline-flex align-items-center' style={{gap: '6px'}}>
                  <span className='text-nowrap'>Nomenclatura Cama</span>
                  {watch('CamaIdFake') &&<a
                    onClick={() => setShowModalLastGuests(true)}
                    title='Ver últimos huéspedes'
                    className={clsx(
                      'text-decoration-underline fs-8 d-inline-block mw-md-50px mw-lg-50px mw-xl-120px mw-xxl-120px',
                      {'cursor-pointer': !camaId || !huespedId},
                    )}
                    style={{
                      minWidth: '70px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      verticalAlign: 'bottom',
                    }}
                  >
                    Ver últimos huéspedes
                  </a>}
                </span>
              }
              name='CamaIdFake'
              data={beds}
              onChangeValue={handleBedChange}
              // disabled={buttonsDisabled}
            />
          </div>

          {/* <button
            type='button'
            className='btn btn-icon btn-sm btn-light-primary ms-2'
            onClick={() => setShowModalLastGuests(true)}
            title='Ver últimos huéspedes'
            disabled={!camaId || !huespedId}
          >
            <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-2' />
          </button> */}
        </div>
        {bedStatus && (
          <div className='mb-2 col-sm-12 col-lg-3'>
            <label>Estado Cama:</label>
            <div className='mt-2'>
              <div className='flex '>
                <span
                  className={clsx(
                    'badge fs-6',
                    bedStatus !== 'DISPONIBLE' ? 'badge-danger' : 'badge-success',
                  )}
                >
                  {bedStatus}
                </span>
                {bedStatus !== 'DISPONIBLE' && (
                  <button
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-2'
                    onClick={() => {
                      setShowModalBedGuest(true)
                    }}
                    type='button'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-3' />
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className='row mt-4'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='radio'
              name='tipoBusqueda'
              id='disponibles'
              checked={tipoBusqueda === 'disponibles'}
              // disabled={buttonsDisabled}
              onChange={() => handleTipoBusquedaChange('disponibles')}
            />
            <label className='form-check-label' htmlFor='disponibles'>
              Disponibles
            </label>
          </div>
        </div>

        <div className='mb-2 col-sm-12 col-lg-3'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='radio'
              name='tipoBusqueda'
              id='ocupadas'
              checked={tipoBusqueda === 'ocupadas'}
              // disabled={buttonsDisabled}
              onChange={() => handleTipoBusquedaChange('ocupadas')}
            />
            <label className='form-check-label' htmlFor='ocupadas'>
              Ocupadas
            </label>
          </div>
        </div>
      </div>

      <div className='row mt-4'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <CheckWrapper name='CheckOutRelevo' labelText='CheckOut - Relevo' disabled />
        </div>

        <div className='mb-2 col-sm-12 col-lg-3'>
          <CheckWrapper name='ReservaYCheckin' labelText='Reserva y Checkin' disabled={true} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <CheckWrapper name='Impresion' labelText='Impresión' />
        </div>
      </div>
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      {showModalCreateGuest && (
        <ModalCreateGuest
          key={pendingDocumento?.numero || 'modal-guest'}
          show={showModalCreateGuest}
          setShow={setShowModalCreateGuest}
          campamentoId={campamentoId || ''}
          onGuestCreated={handleGuestCreated}
          numeroDocumento={pendingDocumento?.numero || ''}
          tipoDocumentoId={pendingDocumento?.tipo || '01'}
        />
      )}
      {showModalBedGuest && (
        <ModalInfoBedGuest
          show={showModalBedGuest}
          setShow={setShowModalBedGuest}
          bedInfo={bedInfo}
        />
      )}
      {showModalCreateCargo && (
        <ModalCreateCargo
          show={showModalCreateCargo}
          setShow={setShowModalCreateCargo}
          onCargoCreated={handleCargoCreated}
          huespedId={huespedId}
        />
      )}
      {showModalCreateStatus && (
        <ModalCreateCargo
          show={showModalCreateCargo}
          setShow={setShowModalCreateCargo}
          onCargoCreated={handleCargoCreated}
          huespedId={huespedId}
        />
      )}
      {showModalLastGuests && (
        <ModalLastGuests
          show={showModalLastGuests}
          setShow={setShowModalLastGuests}
          campamentoId={campamentoId}
          camaId={camaId}
          onSelectGuest={handleSelectGuestFromModal}
        />
      )}
      {showModalLastBeds && (
        <ModalLastBeds
          show={showModalLastBeds}
          setShow={setShowModalLastBeds}
          campamentoId={campamentoId}
          huespedId={huespedId}
          onSelectBed={handleSelectBedFromModal}
        />
      )}
    </div>
  )
}

export {FormBookingftf}
